import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function CommerceScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-769">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-770">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-771">
          <div data-id="element-772">
            <h2 className="text-4xl text-ink mb-8" data-id="element-773">Class Times</h2>
            <ScheduleTable data-id="element-774" />
          </div>
          <div data-id="element-775">
            <h2 className="text-4xl text-ink mb-8" data-id="element-776">Location Details</h2>
            <LocationBlock data-id="element-777" />
          </div>
        </div>
      </div>
    </section>;
}